<template>
  <sc-render :fields="fields" :empty-message="$t('NO_DATA_SOURCE_EXIST')">
    <sc-clickable
      class="product-tile"
      :class="{
        'product-tile--edit': isEditMode,
        'product-tile--dark': isDarkTheme
      }"
      :href="ctaHref"
      target="_blank"
    >
      <image-card :is-large="true">
        <template #image="{widthView}">
          <media-display
            :fraction="widthView"
            :sc-image-field="imageField"
            :image-desktop-source="imageSrc"
          />
        </template>
        <template #title>
          <heading
            v-if="isEditMode || title"
            class="product-tile__title"
            desktop-size="size-5"
            mobile-size="size-5"
            default-tag="h3"
            :text-field="titleField"
          />
        </template>
        <template #tag>
          <sc-text
            v-if="isEditMode || tag"
            class="product-tile__tag"
            :field="tagField"
          />
        </template>
        <template>
          <span
            v-if="isEditMode || oldPrice"
            class="product-tile__price product-tile__price--old"
          >
            <sc-text :field="oldPriceField || {}" />
          </span>
          <span
            v-if="isEditMode || price"
            class="product-tile__price"
          >
            <sc-text :field="priceField || {}" />
          </span>
          <div class="product-tile__cta">
            <sh-button :[ctaStyle]="true">
              {{ ctaText }}
            </sh-button>
          </div>
        </template>
      </image-card>
    </sc-clickable>
  </sc-render>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Text } from '@sitecore-jss/sitecore-jss-vue'
import { ImageCard, ShButton } from '@sohohouse/design-system'
import ScRender from '~/components/sitecore/sc-render'
import ScClickable from '~/components/sitecore/sc-clickable'
import Heading from '~/components/sitecore/heading'
import MediaDisplay from '~/components/sitecore/media-display'
import mapFields from '~/helpers/map-fields'
import getButtonStyle from '~/helpers/get-button-style'
import ThemeMixin from '~/mixins/theme'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'ProductTile',

  components: {
    ScText: Text,
    ImageCard,
    ShButton,
    ScRender,
    ScClickable,
    Heading,
    MediaDisplay
  },

  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },

  mixins: [ThemeMixin],

  computed: {
    ...mapJssGetters(['isEditMode']),

    ...mapFields({
      imageField: 'image',
      imageSrc: 'image.value.cloudinary_3x4_fill_crop',
      titleField: 'productTitle',
      title: 'productTitle.value',
      tagField: 'tag',
      tag: 'tag.value',
      priceField: 'price',
      price: 'price.value',
      oldPriceField: 'oldPrice',
      oldPrice: 'oldPrice.value',
      ctaHref: 'cta.value.href',
      ctaText: 'cta.value.text',
      ctaAppearance: 'ctaAppearance.value'
    }),

    ctaStyle () {
      return getButtonStyle(this.ctaAppearance)
    }
  }
}
</script>

<style lang="scss" scoped>
.product-tile {
  text-decoration: none;

  & &__title {
    @include font('060');
  }

  &__price {
    display: inline-block;
    @include font('040');
    @include stack-space($space-030);

    &--old {
      text-decoration: line-through;
      margin-right: $space-010;
    }
  }

  &__tag {
    color: $color-slate-gray;
  }

  &--dark &__tag {
    color: $color-cream;
  }

  &--edit {
    margin-right: ($space-050);
  }
}
</style>
